// import IndexStep from "../../../../../App/Courses/Declaration/IndexStep";
import Client from "../../../../../Objects/models/Client";
import { useDispatch } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";
import React, { useState } from "react";
import {
  displayError,
  getMinute,
  validateDateTime,
  validateMultiDate,
} from "../../../../../Utils/Function";
import { SET_COURSE_DECLARATION_INFO } from "../../../../../Redux/Reducers/DeclarationCourseReducers";
import Functions from "../../../../../Helpers/Functions";
import { Alert } from "@mui/material";
import MultiDatePicker from "../../../../../Components/MultiDatePicker";
import type { DataChildType, DataDisptachType } from "../../CourseDeclare";
import { CourseType, courseTypes } from "../../staticData";
import TimeFields from "../../../../../Components/Fields/TimeFields";
import DateFields from "../../../../../Components/Fields/DateFields";
import DurationFields from "../../../../../Components/Fields/DurationFields";
import IndexStep from "../../../../../App/DeclarationCourse/IndexStep";

type Props = {
  client?: Client;
  generalStep: any;
  handleChangeStep: (val: number) => void;
  dataChild: DataChildType;
  dataDispatch: DataDisptachType;
};

export default function SecondStep({ generalStep, handleChangeStep }: Props) {
  moment.locale("fr");

  const dispatch = useDispatch();

  const secondStep = generalStep?.secondStep;
  const courseType = generalStep?.courseType as CourseType;
  const courseIsMonth = generalStep?.cours;
  const today = new Date();
  const tomorrow = today.setDate(today.getDate() + 1);

  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  const todayHour20 = moment(today).format("YYYY-MM-DD HH:mm:ss");
  const lastDayHour20 = moment(lastDayOfMonth).format("YYYY-MM-DD 20:00:00");

  const start = moment().add(0.2, "hours");
  const end = moment().add(1.7, "hours");
  const now = moment().format("YYYY-MM-DD");

  const defaultResult = [
    secondStep && secondStep?.startDatetimeMore
      ? new Date(secondStep?.startDatetimeMore)
      : new Date(moment().startOf("month").format("YYYY-MM-DD HH:mm:ss")),
    secondStep && secondStep?.endDatetimeMore
      ? new Date(secondStep?.endDatetimeMore)
      : new Date(moment().format("YYYY-MM-DD HH:mm:ss")),
  ];

  const timeWithMinuteStart = moment(start).minute(getMinute(start.minute()));
  const timeWithMinuteEnd = moment(end).minute(getMinute(end.minute()));

  const [date, setDate] = useState(secondStep ? secondStep?.date : today);

  let initialDuration = 1.5;

  if (secondStep) {
    if (courseIsMonth) {
      initialDuration = secondStep.durationMore ?? 1.5;
    } else {
      initialDuration = secondStep.duration ?? 1.5;
    }
  }
  const [duration, setDuration] = useState(initialDuration);

  React.useEffect(() => {
    const now = new Date();
    if (courseType === "urgent") {
      const now = moment();
      let start = now.add(2.5, "hours");
      const minutes = start.minutes();
      const roundedMinutes = Math.ceil(minutes / 15) * 15;
      start = start.minutes(roundedMinutes).seconds(0).milliseconds(0);
      const end = moment(start).add(duration, "hours").toDate();

      setStartTime(start.toDate());
      setEndTime(end);
      setDate(moment().startOf("day").toDate());
    } else if (courseType === "punctual") {
      const tomorrow = moment(now).add(1, "day").startOf("day").toDate();
      const roundedStart = moment(tomorrow)
        .hour(8)
        .minute(0)
        .second(0)
        .millisecond(0)
        .toDate();
      const end = moment(roundedStart).add(duration, "hours").toDate();

      setStartTime(roundedStart);
      setEndTime(end);
      setDate(tomorrow);
    }
  }, [courseType, duration]);

  const [startTime, setStartTime] = useState(
    secondStep && secondStep?.startDatetime
      ? new Date(secondStep?.startDatetime)
      : timeWithMinuteStart.toDate()
  );

  const [endTime, setEndTime] = useState(
    secondStep && secondStep?.endDatetime
      ? new Date(secondStep?.endDatetime)
      : timeWithMinuteEnd.toDate()
  );

  const [datesValues, setDatesValues] = useState();
  // const [notes, setNotes] = useState("");
  const [errorEndTime, setErrorEndTime] = useState({ endTime: false });
  const [errorTime, setErrorTime] = useState({ time: false });
  const [errorDates, setErrorDates] = useState({ dates: false });
  const [msgErrorEndTime, setMsgErrorEndTime] = useState({ endTime: "" });
  const [msgErrorDates, setMsgErrorDates] = useState({ dates: "" });

  const actuallyHours = moment().format("HH:mm");
  const courseHours = Functions.renderTime(startTime);
  const hoursCondition = courseHours <= actuallyHours;
  const dayCondition =
    moment(date).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD");

  const getDate = (value: string) => {
    if (value !== "") {
      const date = moment(value).format("YYYY-MM-DD");
      if (now === date) {
        setStartTime(timeWithMinuteStart.toDate());
        setEndTime(moment(timeWithMinuteStart).add(duration, "hours").toDate());
      }
      setDate(value);
    }
  };

  const validate = () => {
    let isEndTime = true;
    let isDateValid = true;
    let isValidHour = true;

    const endTimeValidation = validateDateTime(duration, startTime, endTime);
    const dateValidation = courseIsMonth && validateMultiDate(datesValues);

    if (!endTimeValidation.isValid) {
      setErrorEndTime({ endTime: true });
      isEndTime = false;
    } else {
      setErrorEndTime({ endTime: false });
      isEndTime = true;
    }
    if (courseIsMonth) {
      if (dateValidation.error) {
        setErrorDates({ dates: true });
        isDateValid = false;
      } else {
        setErrorDates({ dates: false });
        isDateValid = true;
      }
    }

    let minStart = moment().add(2.5, "hours");
    const minutes = minStart.minutes();
    const roundedMinutes = Math.ceil(minutes / 15) * 15;
    minStart.minutes(roundedMinutes).seconds(0).milliseconds(0);

    if (dayCondition) {
      if (hoursCondition) {
        setErrorTime({ time: true });
        isValidHour = false;
      } else {
        setErrorTime({ time: false });
        isValidHour = true;
      }
    }

    setMsgErrorEndTime({ endTime: endTimeValidation.message });
    if (dateValidation) {
      setMsgErrorDates({ dates: dateValidation.message });
    }

    return courseType ? isDateValid : isEndTime && isValidHour;
  };

  const handleNextStep = (value: number) => {
    let startDateTime, endDateTime;
    let dateCourse;

    if (courseType === "urgent") {
      dateCourse = moment();
    } else if (date && dayjs.isDayjs(date)) {
      dateCourse = moment(date.format("YYYY/MM/DD"));
    } else {
      dateCourse = moment(date);
    }

    if (!validate()) return;

    if (courseType === "urgent") {
      startDateTime = startTime;
      endDateTime = moment(startTime).add(duration, "hours").toDate();
    }

    if (!courseIsMonth && courseType !== "urgent") {
      startDateTime = dateCourse
        .set("hour", moment(startTime).hours())
        .set("minutes", moment(startTime).minutes())
        .toDate();
      endDateTime = dateCourse
        .set("hour", moment(endTime).hours())
        .set("minutes", moment(endTime).minutes())
        .toDate();
    }

    const secondStepPayload = {
      date: dateCourse.toDate().toISOString(),
      duration: duration,
      startDatetime:
        startDateTime?.toISOString() ||
        timeWithMinuteStart.toDate().toDateString(),
      endDatetime:
        endDateTime?.toISOString() || timeWithMinuteEnd.toDate().toDateString(),
      note: "",
    };

    dispatch({
      type: SET_COURSE_DECLARATION_INFO,
      payload: {
        ...generalStep,
        step: value,
        secondStep: secondStepPayload,
      },
    });
    handleChangeStep(value);
  };

  const displayBody = () => {
    return (
      <>
        <div
          className={`grid ${courseIsMonth ? "md:grid-cols-2 md:gap-4 md:gap-y-6" : ""
            } grid-cols-1 gap-y-6`}
        >
          {courseType === "urgent" ? (
            <>
              <TimeFields
                value={startTime}
                endValue={endTime}
                date={date}
                setEndTime={setEndTime}
                setStartTime={setStartTime}
                duration={duration}
                today={startTime}
                // startAt={startTime}
                label="Heure de début des cours"
              />
            </>
          ) : courseIsMonth ? (
            <MultiDatePicker
              startAt={new Date().toISOString()}
              customMultiDatePicker={""}
              defaultValue={defaultResult}
              setStartDate={setStartTime}
              setEndDate={setEndTime}
              setDatesValues={setDatesValues}
              label="La période des cours"
            />
          ) : (
            <>
              <div className="grid md:grid-cols-2 gap-4">
                <TimeFields
                  value={startTime}
                  endValue={endTime}
                  date={date}
                  setEndTime={setEndTime}
                  setStartTime={setStartTime}
                  duration={duration}
                  today={startTime}
                  label="Heure de début des cours"
                />
                <div className="relative cursor-not-allowed px-4 py-1 rounded-lg bg-inputColor shadow-dashboard-setup-input h-max">
                  <label className="block lg:text-base cursor-not-allowed">
                    Heure de fin des cours
                  </label>
                  <input
                    disabled
                    value={moment(endTime).format("HH:mm")}
                    className={`w-full lg:text-base bg-transparent cursor-not-allowed placeholder:text-grey`}
                    type="text"
                  />
                </div>
              </div>
              <DateFields
                customDate=""
                getDate={getDate}
                value={date}
                minDate={tomorrow}
                maxDate={moment().add(2, "years").toDate()}
                label="Jour du cours"
              />
            </>
          )}

          <DurationFields
            customDuration={""}
            value={Functions.renderDuration(duration * 2)}
            isPunctualMonth={courseIsMonth}
            duration={duration}
            setDuration={setDuration}
            setEndTime={setEndTime}
            startTime={startTime}
            label="Durée de cours"
          />
        </div>

        <div className={``}>
          {courseIsMonth ? (
            displayError(errorDates.dates, msgErrorDates.dates)
          ) : (
            <div>
              {displayError(errorEndTime.endTime, msgErrorEndTime.endTime)}
              {displayError(
                errorTime.time,
                "L'heure de début du cours que vous avez indiquée est déjà écoulée. Merci de modifier l'heure de début."
              )}
            </div>
          )}
        </div>
        {courseIsMonth && todayHour20 >= lastDayHour20 && (
          <Alert variant="outlined" severity="warning" className="font-nunito">
            Attention /!\ Nous sommes le dernier jour du mois et il est 20h
            passé, il n'est plus possible de déclarer vos cours pour le mois en
            cours. Veuillez attendre jusqu'au 1er du mois prochain pour déclarer
            vos cours.
          </Alert>
        )}
      </>
    );
  };

  return (
    <IndexStep
      title={`${courseTypes[courseType]} 📚`}
      handleNexStep={handleNextStep}
      handleChangeStep={handleChangeStep}
      body={displayBody()}
      value={3}
      step={2}
    />
  );
}
